module.exports = __webpack_public_path__ + "static/media/ic_ professional_info.40dbbe21.svg";